// @flow
import * as React from 'react';
import type { Element } from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { DETAILS_TREATMENT } from '@routes';
import { Link, useTranslation } from '@i18n';
import { SVGImageFixedAspectRatio } from '@components/SVG';

import {
  StyledWrapper,
  StyledListItem,
  StyledTextContainer,
  StyledPositionText,
  StyledDepartmentText,
  StyledStartDateText,
  StyledLink,
  StyledIcon,
  StyledStayingDays,
  StyledCostWrapper,
  StyleText,
  StyledImageContainer,
  StyledSucessrate
} from './styles';

import type { Props } from './types';

const SearchResultListItem = ({ result, size }: Props): Element<any> => {
  const { t } = useTranslation('Treatments');

  const treatment = result.attributes;
  return (
    <StyledWrapper size={size}>
      <StyledListItem>
        <StyledImageContainer>
          <Link href={DETAILS_TREATMENT} params={{ slug: treatment.slug }} passHref>
            <StyledLink Image>
              <SVGImageFixedAspectRatio
                imageUrl={treatment.photo_url || '/images/finder/treatment_2.png'}
                imageAlt={treatment.photo_alt_tag || ''}
                imageWidth="533"
                imageHeight="400"
              />
            </StyledLink>
          </Link>
        </StyledImageContainer>
        <StyledTextContainer>
          <StyledPositionText>
            <Link href={DETAILS_TREATMENT} params={{ slug: treatment.slug }} passHref>
              <StyledLink Treatment>{treatment?.name}</StyledLink>
            </Link>
          </StyledPositionText>
          <StyledDepartmentText>
            {(treatment?.department || '').split('_').join(' ') || '-'}
          </StyledDepartmentText>
          <StyledStayingDays>
            {treatment.days_in_hospital ? t('DaysInHospital', treatment) : ''}
            {' '}
          </StyledStayingDays>
          <StyledSucessrate>
            {treatment.success_rate ? t('SuccessRate', treatment) : ''}
          </StyledSucessrate>
          <StyledCostWrapper>
            {t('Cost')}
            <StyleText>
              <br />
              {treatment.total_approx_cost
                ? t('CostValue', treatment).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : t('CostValueRange', treatment).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            </StyleText>
          </StyledCostWrapper>
        </StyledTextContainer>
        <Link href={DETAILS_TREATMENT} params={{ slug: treatment.slug }} passHref>
          <StyledLink startDate>
            <StyledStartDateText>
              {t('BookConsultation')}
              <StyledIcon icon={faChevronRight} size="xs" />
            </StyledStartDateText>
          </StyledLink>
        </Link>
      </StyledListItem>
    </StyledWrapper>
  );
};

export default SearchResultListItem;
